import * as React from 'react';
import { SVGProps } from 'react';

const SvgVisibilityOn = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 5.968c3.79 0 7.17 2.119 8.82 5.471-1.65 3.352-5.03 5.471-8.82 5.471s-7.17-2.119-8.82-5.471C4.83 8.087 8.21 5.968 12 5.968zm0-1.989c-5 0-9.27 3.094-11 7.461 1.73 4.367 6 7.461 11 7.461s9.27-3.094 11-7.461c-1.73-4.367-6-7.461-11-7.461zm0 4.974c1.38 0 2.5 1.114 2.5 2.487s-1.12 2.487-2.5 2.487-2.5-1.114-2.5-2.487A2.494 2.494 0 0 1 12 8.953zm0-1.99c-2.48 0-4.5 2.009-4.5 4.476s2.02 4.476 4.5 4.476 4.5-2.009 4.5-4.476-2.02-4.476-4.5-4.476z" />
  </svg>
);

export default SvgVisibilityOn;
